export enum TagGamificationEnum {
  MISSIONS = 'missions',
  RANKS = 'ranks',
  REWARD_SHOP = 'reward_shop',
  TOKEN_RULES = 'token-rules',
  XP_POINTS = 'xp-points',
  TOURNAMENTS = 'tournaments',
}
